import React, { useState } from "react";
import usePageTitle from '../../hooks/usePageTitle';
import { usePartner } from '../../context/PartnerContext';
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  usePageTitle("Forgot Password");
  const { appName, logoUrl, partner, loading: brandLoading, tagline } = usePartner();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    setStatus("");
    try {
      const res = await fetch("/api/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to send reset email");
      setStatus("Reset link sent. Check your inbox.");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-panel">
        <div className="auth-brand">
          <div className="auth-brand-logo" style={{display:"flex",alignItems:"center",gap:8,justifyContent:"center"}}>{(logoUrl || (!partner && !brandLoading)) && <img src={logoUrl || "/logo.jpeg"} alt={appName || "CrunchAlpha"} style={{height:32,width:32,borderRadius:6,objectFit:"cover"}} onError={e=>e.target.style.display="none"}/>} {appName || "CrunchAlpha"}</div>
          {(partner ? tagline : "Risk Controlled Copy Trading") && <div className="auth-brand-tagline">{partner ? tagline : "Risk Controlled Copy Trading"}</div>}
        </div>
        <div className="auth-card">
          <h2>Forgot password</h2>
          <p className="auth-subtitle">Enter your email and we'll send you a reset link.</p>
          {status && (
            <div style={{padding:"10px 14px",borderRadius:"var(--radius-md)",
              border:"1px solid rgba(34,197,94,0.4)",background:"var(--success-soft)",
              color:"var(--success)",fontSize:13,marginBottom:16}}>
              {status}
            </div>
          )}
          {error && <div className="auth-error">{error}</div>}
          <form onSubmit={handleSubmit} className="auth-form">
            <label>
              <span>Email address</span>
              <input type="email" required autoComplete="email"
                value={email} onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com" />
            </label>
            <button type="submit" className="auth-button" disabled={busy}>
              {busy ? "Sending..." : "Send reset link"}
            </button>
          </form>
        </div>
        <p className="auth-footer">
          Remember your password? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
